import { render, staticRenderFns } from "./Detalhe_Empresas.vue?vue&type=template&id=c2983bc0&scoped=true&"
import script from "./Detalhe_Empresas.vue?vue&type=script&lang=js&"
export * from "./Detalhe_Empresas.vue?vue&type=script&lang=js&"
import style0 from "./Detalhe_Empresas.vue?vue&type=style&index=0&id=c2983bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2983bc0",
  null
  
)

export default component.exports